import {GenericEmbeddedResourceInfo, GenericLinkedResource} from '@catcore/types/base';

export const linkedResourceToGenericEmbeddedResource = (item: GenericLinkedResource): GenericEmbeddedResourceInfo => {
  return {
    name: item.label,
    _links: {
      self: {href: item.href},
    },
  };
};



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/core/utils/json-resources.ts